import React from "react";
import styled from "styled-components";
import { skillData } from "../data";
import Universe from "./Universe";

const AnnouncementForJob = styled.h2`
  color: #fff;
  text-align: center;
`;
const SkillBox = styled.div`
  width: 300px;
  height: auto;
  flex-wrap: wrap;
  margin: auto;
  @media (max-width: 770px) {
    width: 100%;
  }
`;
const SkillListItemBox = styled.div`
  display: flex;
  border-radius: 100%;
  width: 54px;
  height: 54px;
  background: #251c31;
  justify-content: center;
  align-items: center;
  margin: 10px;
`;
const SkillListItem = styled.span`
  display: inline-block;
  width: 30px;
  height: 30px;
  background-image: url(${(props) => props.data});

  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;
const Skills = () => {
  return (
    <>
      <AnnouncementForJob>
        I'm currently looking to join a{" "}
        <span style={{ color: "#7127BA", display: "inline-block" }}>
          cross-functional
        </span>{" "}
        team <br />
        <span style={{ fontSize: "14px" }}>
          that values improving people's lives through accessible design
        </span>
      </AnnouncementForJob>
      <SkillBox className="d-flex justify-center align-center">
        {skillData.map((d, i) => (
          <SkillListItemBox key={i}>
            <SkillListItem data={d.image} title={d.title} />
          </SkillListItemBox>
        ))}
      </SkillBox>
      <Universe />
    </>
  );
};

export default Skills;
